module.exports = __webpack_public_path__ + "img/chevron-up.8fc9f6ab.svg";